{
  "de": {
    "dashboard": {
      "showAll": "Alle anzeigen",
      "empty": "Hier gibt es noch nichts.",
      "failed": "Konnte gerade nicht geladen werden."
    }
  }
}
